<div class="zk-flex zk-flex-col zk-gap-2">
	<div class="zk-flex zk-flex-row zk-gap-2">
		<p freud-typography fontType="h4SemiboldAuto">
			{{ getSessionTypeLabel() }}
		</p>
		<p *ngIf="shouldShowSessionModel()" freud-typography fontType="h4SemiboldAuto">
			- {{ getSessionModelLabel() }}
		</p>
		<custom-tag *ngIf="shouldShowCustomTag()" [icon]="getSessionStatusIcon()" [label]="getSessionStatusLabel()"></custom-tag>  
	</div>
	<div class="zk-flex zk-flex-row">
		<p *ngIf="shouldShowInviteExpirationDate()" class="text" freud-typography fontType="h6RegularAuto">
			{{ 
				'APPOINTMENTS.DETAILS.BODY.SESSION_DATA.EXPIRES_AT' | translate: {
					date: formatDateTime(event.inviteExpirationDate)
				} 
			}} 
		</p>
	</div>
</div>
<div class="zk-grid zk-gap-2" [ngClass]="{ 'zk-grid-cols-2': event.professionalAddress || journeySessionProgress, 'zk-grid-cols-3':  !event.professionalAddress && !journeySessionProgress }">
	<div class="zk-flex zk-flex-col">
		<p freud-typography fontType="h5SemiboldAuto">
			{{ 'APPOINTMENTS.DETAILS.BODY.SESSION_DATA.DATE' | translate }} 
		</p>
		<p class="text" freud-typography fontType="h5RegularAuto">
			{{ formatEventDate(event.day) }}
		</p>
	</div>
	<div *ngIf="event.professionalAddress" class="zk-flex zk-flex-col">
		<p freud-typography fontType="h5SemiboldAuto">
			{{ 'APPOINTMENTS.DETAILS.BODY.SESSION_DATA.PLACE' | translate }} 
		</p>
		<div>
			<p class="text" freud-typography fontType="h5RegularAuto">
				{{ event.professionalAddress.name }}
			</p>
			<p class="text" freud-typography fontType="h5RegularAuto">
				{{ event.professionalAddress.street }} -
				{{ event.professionalAddress.number }}
			</p>
		</div>
	</div>
	<div class="zk-flex zk-flex-col">
		<p freud-typography fontType="h5SemiboldAuto">
			{{ 'APPOINTMENTS.DETAILS.BODY.SESSION_DATA.TIME' | translate }} 
		</p>
		<p class="text" freud-typography fontType="h5RegularAuto">
			{{ event.startTime }} - {{ event.endTime }}
		</p>
	</div>
	<div class="zk-flex zk-flex-col">
		<p freud-typography fontType="h5SemiboldAuto">
			{{ 'APPOINTMENTS.DETAILS.BODY.SESSION_DATA.SCHEDULED_AT' | translate }} 
		</p>
		<p class="text" freud-typography fontType="h5RegularAuto">
			{{ formatEventDate(event.createdAt) }}
		</p>
	</div>
	<div *ngIf="journeySessionProgress" class="zk-flex zk-flex-col">
		<p freud-typography fontType="h5SemiboldAuto">
			{{ 'APPOINTMENTS.DETAILS.BODY.SESSION_DATA.PROGRESS' | translate }}
		</p>
		<p class="text" freud-typography fontType="h5RegularAuto">
			{{ journeySessionProgress.label }}
			<ng-container *ngIf="journeySessionProgress.total > 0">
				{{ 
					'APPOINTMENTS.DETAILS.BODY.SESSION_DATA.PROGRESS_DESCRIPTION' | translate: { 
						current: journeySessionProgress.current, 
						total: journeySessionProgress.total 
					} 
				}}
			</ng-container>
		</p>
	</div>
</div>